import { FullStoryAPI } from '@zapier/react-fullstory';
export const emitFullStoryEvent = (properties) => {
    FullStoryAPI('event', properties.interaction_name, properties);
};
//# sourceMappingURL=fullStoryEvents.js.map
// @zapier/universal-layout@9.12.4 (a02ac1bd0)
